<script setup>
import { defineEmits, defineProps, computed, toRefs } from "vue"

const props = defineProps({
  modelValue: {}
});

const { modelValue } = toRefs(props);

const emit = defineEmits(['update:modelValue'])

const value = computed({
  get: () => props.modelValue?.data?.value,
  set: (newValue) => emit('update:modelValue', {
    ...props.modelValue,
    data: { ...props.modelValue.data, value: newValue }
  })
})
</script>

<template>
  <div>
    <p>Текст для отображения</p>
    <a-textarea v-model:value="value" />
  </div>
</template>

<style lang="scss" scoped>
</style>